import React from "react";

const LaunchReport = ({ launchURL, id}) => {
  console.log("id", id);
  const url = launchURL.split("Report" + id)[0];
  const token = launchURL.split("Report" + id)[1];
  return (
    <React.Fragment>
      <main className="divider rPad">
        <div className="container">
          <div className="row">
            <tableau-viz
            id='tableauViz'
            toolbar="bottom" 
            src={url}
            token={token}
        ></tableau-viz>
          </div>
        </div>
      </main>
    </React.Fragment>
  );
};

export default LaunchReport;
